
import { createContext } from "react";

// var ScrollState = {
//   slug: {
//     obstructed: false,
//     overlay: false,
//     highlighted: false,
//     active: false,
//   }
// };

export const StackedPagesContext = createContext({
  stackedPages: [],
  stackedPageStates: {},
  navigateToStackedPage: () => {},
  highlightStackedPage: () => {},
  closeStackedPage: () => {},
});

export const StackedPagesIndexContext = createContext(0);

export const StackedPagesProvider = StackedPagesContext.Provider;
export const PageIndexProvider = StackedPagesIndexContext.Provider;
